import React, { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export const PasswordInput = forwardRef(({ className, wrapperClassName, ...props }, ref) => {
  const [ver, setVer] = useState(false);
  const tid = props["data-testid"];
  return (
    <div className={cn("relative", wrapperClassName)}>
      <Input ref={ref} {...props} type={ver ? "text" : "password"} className={cn(className, "pr-10")} />
      <button type="button" tabIndex={-1} onClick={() => setVer((v) => !v)} aria-label={ver ? "Ocultar" : "Mostrar"}
              data-testid={tid ? `${tid}-eye` : undefined}
              className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-slate-400 hover:text-sky-600 transition-colors">
        {ver ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";
